import { render, staticRenderFns } from "./comp-dragList.vue?vue&type=template&id=f6f873be"
import script from "./comp-dragList.vue?vue&type=script&lang=js"
export * from "./comp-dragList.vue?vue&type=script&lang=js"
import style0 from "./comp-dragList.vue?vue&type=style&index=0&id=f6f873be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports